import React, { useState, useEffect } from "react";
import Navigation from "./Navigation";

const Layout = ({ children }) => {
  const [isCollapsed, setIsCollapsed] = useState(() => {
    // Check if we're on mobile by default
    if (typeof window !== "undefined" && window.innerWidth < 768) {
      return true;
    }
    // Otherwise check localStorage
    const saved = localStorage.getItem("sidebarCollapsed");
    return saved === "true";
  });

  useEffect(() => {
    // Handle window resize to auto-collapse on mobile
    const handleResize = () => {
      if (window.innerWidth < 768) {
        setIsCollapsed(true);
      }
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const toggleSidebar = () => {
    const newState = !isCollapsed;
    setIsCollapsed(newState);
    localStorage.setItem("sidebarCollapsed", newState.toString());
  };

  return (
    <div className="flex h-screen bg-cf-gray-50">
      {/* Sidebar Navigation */}
      <Navigation isCollapsed={isCollapsed} />

      {/* Main Content Area */}
      <div className="flex-1 flex flex-col overflow-hidden">
        {/* Header */}
        <div className="bg-white border-b border-cf-gray-200 px-4 py-3">
          <div className="flex items-center gap-4">
            <button
              onClick={toggleSidebar}
              className="p-2 rounded-cf text-cf-gray-600 hover:bg-cf-gray-100 hover:text-cf-gray-900 transition-colors"
              aria-label={isCollapsed ? "Expand sidebar" : "Collapse sidebar"}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-5 w-5"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M4 6h16M4 12h16M4 18h16"
                />
              </svg>
            </button>

            {/* Logo and Title */}
            <div className="flex items-center gap-3">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="65.2 173.5 32 32"
                width="32"
                height="32"
                fill="#0080FF"
              >
                <path d="M81.202 205.5v-6.2c6.568 0 11.666-6.5 9.144-13.418a9.27 9.27 0 0 0-5.533-5.531c-6.912-2.502-13.425 2.575-13.425 9.14H65.2c0-10.463 10.124-18.622 21.1-15.195 4.8 1.505 8.618 5.313 10.105 10.1 3.43 10.99-4.717 21.107-15.203 21.107z" />
                <path d="M75.05 199.317v-6.165h6.168v6.165zm-4.753 4.75v-4.75h4.753v4.75h-4.753zm0-4.75h-3.973v-3.97h3.973v3.97z" />
              </svg>
              <div>
                <div className="font-semibold text-base text-cf-gray-900">
                  DO Cost Explorer
                </div>
                <div className="text-xs text-cf-gray-600">
                  Comprehensive cost analysis for your DigitalOcean resources
                </div>
              </div>
            </div>
          </div>
        </div>

        <main className="flex-1 overflow-y-auto">{children}</main>
      </div>
    </div>
  );
};

export default Layout;
